import dropdownMenuContent from "./DropdownMenuContent";

export const clickHandler = (setMenuContent) => {
	setMenuContent(false);
};

const mouseoverHandler = (e, setMenuContent) => {
	if (e.target.dataset.content) {
		if (
			e.target.dataset.content === "inicio" ||
			e.target.dataset.content === "contacto"
		) {
			setMenuContent(false);
		} else {
			return setMenuContent({
				selectedLink: e.target.dataset.content,
				content: dropdownMenuContent[e.target.dataset.content],
			});
		}
	} else {
		return;
	}
};

export default mouseoverHandler;
